import { useContracts } from 'components/contracts/useContracts';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { ContractFilter } from './ui/filters/ContractFilter';
import { useHistory, useParams } from 'react-router-dom';
import { Postbox } from './Postbox';
import { postboxPagePath } from 'components/navigation/paths';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';

const PostboxWithHandlers = withLoadingAndNoConnectionHandler(Postbox);

export const PostboxWrapper: React.FC = () => {
    const { t } = useTranslation('postbox');
    const { data: contracts, isLoading: isLoadingContracts, loadingError: loadingErrorContracts } = useContracts();
    const params = useParams<{ contractId: string }>();
    const [contractId, setContractId] = useState<string>(params.contractId);
    const history = useHistory();
    const contractFilterChange = (selectedContract: string) => {
        const currentContract =
            (selectedContract && !params.contractId) || (selectedContract && selectedContract !== params.contractId);
        if (selectedContract !== 'ALL' && currentContract) {
            setContractId(selectedContract);
            history.push(postboxPagePath(selectedContract));
        }
    };
    return (
        <>
            <h3>{t('sub-headline')}</h3>
            <p>{t('description')}</p>
            {!isLoadingContracts && !loadingErrorContracts && (
                <ContractFilter
                    contracts={contracts || []}
                    selectedContract={params.contractId}
                    onChange={contractFilterChange}
                />
            )}
            {contractId && (
                <PostboxWithHandlers
                    isLoading={isLoadingContracts}
                    hasError={!!loadingErrorContracts}
                    contractId={contractId}
                    contracts={contracts || []}
                />
            )}
        </>
    );
};
